import { HEX_121820, HEX_292D38, HEX_477FBA, HEX_7F869D, HEX_ADB5C7 } from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import { defineColor } from '@tanium/react-theme-definition';

export const IconFill = defineColor([HEX_292D38, HEX_ADB5C7]);

export const Toggle = () => HEX_7F869D;
export const ToggleHoverBackground = defineColor([getRgbString(HEX_477FBA, '14%'), HEX_121820]);
